import { Badge, BodyText, Flex } from '@utilitywarehouse/hearth-react';

import { ParticipantAvatar } from '@features/Remote/ParticipantAvatar';
import {
  ParticipantColorScheme,
  UserTypeDisplayMap,
} from '@features/Remote/constants';
import { AppointmentParticipantType } from '@generated/gql/graphql';

import './styles.scss';

interface LobbyListItemProps {
  /* user ID of current remote session user */
  userId: string;
  name: string;
  userType: AppointmentParticipantType;
  participantId: string;
  speaking?: boolean;
}

const LobbyListItem = ({
  userId,
  participantId,
  name,
  userType,
  speaking = false,
}: LobbyListItemProps) => {
  const isYou = userId === participantId;

  return (
    <Flex direction="row" spacing="lg" className="remote__LobbyListItem">
      <ParticipantAvatar userType={userType} name={name} speaking={speaking} />
      <Flex
        direction="column"
        spacing="xs"
        justifyContent="center"
        alignItems="start"
        className="remote__LobbyListItemDetails"
      >
        <BodyText weight="semibold" className="remote__LobbyListItemName">
          {name}
          {isYou && (
            <BodyText as="span" weight="regular" size="sm">
              {' '}
              (You)
            </BodyText>
          )}
        </BodyText>
        <Flex
          direction={{ mobile: 'column', desktop: 'row' }}
          spacing="xs"
          alignItems="baseline"
        >
          <Badge colorScheme={ParticipantColorScheme[userType]} size="sm">
            {UserTypeDisplayMap[userType]}
          </Badge>
          {speaking && (
            <BodyText
              size="sm"
              color="secondary"
              className="remote__LobbyListItemSpeaking"
            >
              Speaking
            </BodyText>
          )}
        </Flex>
      </Flex>
      <Flex direction="row" className="remote__LobbyListItemActions"></Flex>
    </Flex>
  );
};

export { LobbyListItem };
export type { LobbyListItemProps };
